import React from 'react';
import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from '@apollo/client';
import PlanBuilderCeReport from '../../components/Reports/PlanBuilderCeReport';

const httpLink = createHttpLink({
  uri: '/graphql',
  credentials: 'same-origin',
  headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content }
});

const client = new ApolloClient({ link: httpLink, cache: new InMemoryCache() });

const PlanBuilderCeReportContainer = (props) => (
  <ApolloProvider client={client}>
    <PlanBuilderCeReport {...props} />
  </ApolloProvider>
);

export default PlanBuilderCeReportContainer;



